export default {
    UNKNOWN: {
        loadingText: 'Wait for the other players to get ready'
    },
    INTRO: {
        loadingText: 'Wait for the other players to get ready'
    },
    PRE_SEASON: {
        interTitle: {
            title: 'Season {{season}}'
        },
        intro: 'Configure your car items by selecting<br />the buttons below',
        selectorLabel: '{{name}}<br>SELECTION',
        panelDetailsTitle: '{{name}} DETAILS',
        panelLineChartXLabel: 'Asset deterioration (%)',
        panelLineChartYLabel: 'Item expected performance over Pmax (%)',
        panelAMToolLineChartXLabel: '{{name}} expected asset life (km)',
        panelAMToolLineChartYLabel: '{{name}} expected performance (index)',
        panelPerformanceMax: 'Performance max (index)',
        panelExpectedAssetLife: 'Expected asset life (km)',
        kpiIndividualContribution: 'Selected {{name}} individual contribution to performance per USDm invested',
        kpiCombinedContribution: 'Combined assets contribution to performance per USDm invested',
        btnEnd: 'END SELECTION',
        loadingText: 'Wait for the other players to end the selection'
    },
    PRE_RACE: {
        interTitleStart: {
            title: '{{race, toWordsOrdinal}} Race',
            text: 'Season {{season}}'
        },
        interTitleFinishPrevious: {
            title: 'End of {{race, toWordsOrdinal}} Race',
            text: 'Season {{season}}'
        },
        circuit: {
            title: '{{race, toOrdinal}} F1 race: <strong>Grand Prix of {{name}}</strong>',
            characteristics: 'Circuit characteristics:',
            laps: 'Laps',
            lapLength: 'Lap length (km)',
            temperature: 'Track temperature',
            weather: 'Weather',
            humidityLabel: {
                0: 'Mild himidty',
                1: 'Mild humidity',
                2: 'Mild humidity',
                3: 'Mild humidity',
                4: 'Mild humidity'
            }
        },
        intro: 'Select your race strategy by selecting<br />the buttons below',
        cardsTitle: 'Car configuration:',
        pitstops: {
            title: 'Wheel replacement plan',
            plannedCount: 'Planned in-race stops',
            replacementCount: 'Wheel replacement',
            cost: 'Cost per replacement',
            totalCost: 'Total Cost'
        },
        panelAMToolLineChartXLabel: 'Expected asset life (km)',
        panelAMToolLineChartYLabel: 'Tires expected performance (index)',
        btnEnd: 'END SELECTION',
        loadingText: 'Wait for the other players to end the selection'
    },
    RACE: {
        helper: 'Click on the buttons below to see more information:',
        position: 'POSITION',
        points: 'POINTS',
        legend: {
            pitstop: 'Pitstops',
            good: 'Good status',
            medium: 'Medium status',
            critical: 'Critical status',
            broken: 'Broken status'
        },
        loadingText: 'Wait for the other players to check their results',
        nav: {
            raceResults: 'Race Results',
            seeDetails: 'Race ranking',
            cumulative: 'Cumulative ranking',
            seeFastLaps: 'See fast laps',
            seeCurves: 'See curves'
        },
        tableHeaders: {
            position: 'POSITION',
            player: 'PLAYER',
            points: 'POINTS',
            time: 'TIME',
            engine: 'ENGINE',
            gearbox: 'GEARBOX',
            wheels: 'WHEELS',
            race: 'Race {{num}} <small>(speed)</small>'
        },
        wheels: {
            planned: 'Planned',
            corrective: 'Corrective'
        },
        curves: {
            players: 'Players',
            xAxis: 'LAPS',
            yAxis: 'DIFFERENCE VS. 1st CAR IN MINUTES'
        },
        btnEnd: 'GO TO POST RACE',
        btnEndSeason: 'END SEASON'
    },
    POST_RACE: {
        intro: {
            wheels: 'Deviation over initial<br />wheel maintenace plan',
            rest: 'Select what maintenance actions will you conduct<br />on your car components before next race'
        },
        panelLineChartXLabel: 'Asset deterioration (%)',
        panelLineChartYLabel: 'Item expected performance over Pmax (%)',
        choose: 'Select your maintenance plan:',
        btnEnd: 'END RACE',
        loadingText: 'Wait for the other players to end the selection'
    },
    POST_SEASON: {
        interTitle: {
            title: 'End of Season {{season}}'
        },
        byTotalPoints: 'Ranking by total points',
        byProfitability: 'Ranking by profitability',
        tableHeaders: {
            position: 'POSITION',
            player: 'PLAYER',
            totalPoints: 'TOTAL POINTS',
            totalTime: 'TOTAL TIME',
            profitability: 'POINTS/US$m',
            credits: 'US$m'
        },
        btnEnd: 'GO TO NEXT SEASON',
        btnEndGame: 'END GAME & EXIT',
        loadingText: 'Wait for the other players to check their results'
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/game.js